<template>
  <div class="share">
        <b-dropdown position="is-bottom-right" aria-role="list">
        <button class="button is-info is-small" type="button" slot="trigger">
                <p>SNSでシェア</p>
        </button>

        <b-dropdown-item  aria-role="listitem">
            <b-button class="is-info" @click="twitterShare()">Twitterでシェアする</b-button>
        </b-dropdown-item>

        <b-dropdown-item aria-role="listitem">
            <b-button class="line_icon" @click="lineShare()">LINEでシェアする</b-button>
        </b-dropdown-item>
    
        <b-dropdown-item aria-role="listitem">
            <b-button class="facebook_icon" @click="facebookShare()">Facebookでシェアする</b-button>
        </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
export default {
            data() {
            return {
                isPublic: true
            }
        },
    methods:{
        twitterShare(){
            var url = encodeURI(location.href) ;
            var top_twitter_share_url = 'https://twitter.com/intent/tweet?text=' + "「" + this.$route.params.id + "」" + "の夢の意味は？" + "%20%23夢占い" +  "%20%23" + this.$route.params.id + "%20%23夢占い辞典ゆめみん" + "%20" + url
            window.open(top_twitter_share_url, '_blank')
        },
        lineShare(){
            var url = location.href ;
            var top_line_share_url = 'https://social-plugins.line.me/lineit/share?url=' + url
            window.open(top_line_share_url, '_blank')
        },
        facebookShare(){
            var url = location.href ;
            var top_facebook_share_url = 'https://www.facebook.com/share.php?u=' + url
            window.open(top_facebook_share_url, '_blank')
        }
    }

}
</script>

<style scoped>
.line_icon{
  background-color:#00B901;
  color: white;
}
.facebook_icon{
    background-color:#3b5998;
    color: white;
}
</style>